import { InvalidArgumentError } from '@commander-js/extra-typings';
import { z } from 'zod';
import { isProjectSlugValid } from '../project-slug.js';

const schema = z.string().min(1).max(255);

export const validateBusinessName = (value: string) => {
  const result = schema.safeParse(value);
  if (!result.success) {
    throw new InvalidArgumentError('The name must be 1 to 255 characters long');
  }

  isProjectSlugValid(value);

  // https://github.com/wix-private/npm-proto-bazel/blob/master/com_wixpress_proto_projects-service/src/main/proto/wix/api/funnel/project/projects-service.proto#L50
  return value;
};
